import { useParamsContext } from '../../contexts/ParamsContext';
import ServicosForm from './form/Form';
import ServicosList from './list/List';
import ServicosQuickCreateModal from './QuickCreateModal';

export default function Servicos() {
    const { action } = useParamsContext();

    switch (action) {
        case 'quick-add': {
            return (
                <>
                    <ServicosList />
                    <ServicosQuickCreateModal />
                </>
            );
        }
        case 'edit':
        case 'add': {
            return <ServicosForm />;
        }
        case 'list':
        default:
            return <ServicosList />;
    }
}
